// Mock data for Averon Group website

export const heroData = {
  title: "Professional Steam Trap Management, HVAC və Mexaniki Həllər",
  subtitle: "Sənaye və kommersiya obyektləri üçün steam trap management, HVAC, quraşdırma və texniki xidmət həlləri.",
  ctaText: "Əlaqə saxlayın",
  backgroundImage: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/1fnyb0ql_mainhero.jpg"
};

export const servicesData = [
  {
    id: 1,
    slug: "steam-trap-management",
    title: "Steam Trap Sistemlərinin İdarə Olunması",
    description: "Steam trap sistemlərinin auditi, maintenance və Miyawaki məhsullarının rəsmi distribütoru",
    icon: "droplet",
    image: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/2uoy01b0_WhatsApp%20Image%202026-01-11%20at%2010.44.24_upscayl_3x_upscayl-standard-4x.png",
    heroImage: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/2uoy01b0_WhatsApp%20Image%202026-01-11%20at%2010.44.24_upscayl_3x_upscayl-standard-4x.png",
    detailedContent: `
      <h3>Steam Trap Sistemlərinin İdarə Olunması</h3>
      
      <h4>1. Steam trap sistemlərinin auditi və idarə olunması</h4>
      <p>Mövcud steam trap sistemlərinin texniki vəziyyəti qiymətləndirilir, itkilər və qeyri-səmərəli işləyən trap-lar müəyyən edilərək sistemin ümumi buxar səmərəliliyi optimallaşdırılır.</p>
      
      <h4>2. Steam trap maintenance və təmiri</h4>
      <p>Steam trap-ların müntəzəm texniki xidməti və operativ təmiri həyata keçirilərək buxar itkilərinin, enerji sərfinin və planlanmamış dayanma risklərinin qarşısı alınır.</p>
      
      <h4>3. Yeni steam trap-ların seçimi və quraşdırılması</h4>
      <p>İstismar şəraitinə və proses tələblərinə uyğun steam trap-lar seçilir və beynəlxalq standartlara uyğun şəkildə peşəkar quraşdırma işləri icra olunur.</p>
      
      <h4>4. Miyawaki şirkəti ilə əməkdaşlıq</h4>
      <p>Miyawaki şirkəti ilə rəsmi əməkdaşlıq çərçivəsində yüksək keyfiyyətli, etibarlı və enerji səmərəli steam trap həlləri təqdim edilir.</p>
    `
  },
  {
    id: 2,
    slug: "hvac-engineering",
    title: "HVAC Engineering (İsitmə, Soyutma və Ventilyasiya)",
    description: "İsitmə, soyutma və ventilyasiya sistemlərinin layihələndirilməsi və quraşdırılması",
    icon: "wind",
    image: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/xuq956rd_WhatsApp%20Image%202026-01-11%20at%2010.45.09_upscayl_3x_upscayl-standard-4x.png",
    heroImage: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/xuq956rd_WhatsApp%20Image%202026-01-11%20at%2010.45.09_upscayl_3x_upscayl-standard-4x.png",
    detailedContent: `
      <h3>HVAC Engineering (İsitmə, Soyutma və Ventilyasiya)</h3>
      
      <h4>1. İsitmə, soyutma və ventilyasiya sistemlərinin layihələndirilməsi</h4>
      <p>Layihə tələblərinə və istismar şəraitinə uyğun isitmə, soyutma və ventilyasiya sistemləri üçün mühəndis dizaynı hazırlanır.</p>
      
      <h4>2. Fan sistemləri və hava paylama həlləri</h4>
      <p>Effektiv hava axınının təmin edilməsi və məkan daxilində optimal komfortun yaradılması məqsədilə fan sistemləri və hava paylama həlləri layihələndirilir və tətbiq olunur.</p>
      
      <h4>3. HVAC sistemlərinin quraşdırılması</h4>
      <p>Layihə və texniki tələblərə uyğun olaraq HVAC avadanlıqlarının və sistem komponentlərinin peşəkar quraşdırılması, montaj və istismara hazırlıq işləri həyata keçirilir.</p>
      
      <h4>4. HVAC sistemlərinə texniki xidmət və servis</h4>
      <p>HVAC sistemlərinin etibarlı və fasiləsiz işləməsini təmin etmək məqsədilə müntəzəm texniki xidmət, sazlama, nasazlıqların aradan qaldırılması və servis dəstəyi göstərilir.</p>
    `
  },
  {
    id: 3,
    slug: "dinamik-avadanliqlar",
    title: "Dinamik Avadanlıqlar",
    description: "Dinamik avadanlıqların quraşdırılması, shaft alignment və vibrasiyaya qarşı həllər",
    icon: "cog",
    image: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/51ufqatn_WhatsApp%20Image%202026-01-11%20at%2010.43.31_upscayl_3x_upscayl-standard-4x.png",
    heroImage: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/51ufqatn_WhatsApp%20Image%202026-01-11%20at%2010.43.31_upscayl_3x_upscayl-standard-4x.png",
    detailedContent: `
      <h3>Dinamik Avadanlıqlar</h3>
      
      <h4>1. Bütün növ dinamik avadanlıqların quraşdırılması</h4>
      <p>Nasoslar, kompressorlar, fanlar və digər dinamik avadanlıqlar layihə və texniki tələblərə uyğun olaraq peşəkar şəkildə quraşdırılır.</p>
      
      <h4>2. Shaft alignment (lazer və mexaniki üsullarla)</h4>
      <p>Avadanlıqların etibarlı və uzunömürlü işləməsini təmin etmək məqsədilə lazer və mexaniki üsullarla dəqiq shaft alignment işləri icra olunur.</p>
      
      <h4>3. Epoksi komponentli materiallar ilə vibrasiyaya qarşı texniki həllər</h4>
      <p>Avadanlıqların vibrasiyadan qorunması və uzunmüddətli stabil istismarı üçün qabaqcıl 3-komponentli epoksi materiallar tətbiq olunur.</p>
      
      <h4>4. Avadanlıqların sökülməsi, relokasiyası və yenidən quraşdırılması</h4>
      <p>Avadanlıqların təhlükəsiz sökülməsi, yeni sahəyə relokasiyası və yenidən quraşdırılması beynəlxalq standartlara uyğun şəkildə həyata keçirilir.</p>
    `
  },
  {
    id: 4,
    slug: "maintenance-troubleshooting",
    title: "Maintenance, Service & Troubleshooting",
    description: "Mexaniki və HVAC sistemləri üzrə texniki xidmət və nasazlıqların həlli",
    icon: "wrench",
    image: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/usbtz4n3_WhatsApp%20Image%202026-01-11%20at%2010.39.54_upscayl_3x_upscayl-standard-4x.png",
    heroImage: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/usbtz4n3_WhatsApp%20Image%202026-01-11%20at%2010.39.54_upscayl_3x_upscayl-standard-4x.png",
    detailedContent: `
      <h3>Maintenance, Service & Troubleshooting</h3>
      
      <h4>1. Mexaniki və HVAC sistemləri üzrə texniki xidmət</h4>
      <p>Mexaniki və HVAC sistemlərinin etibarlı və fasiləsiz işləməsini təmin etmək məqsədilə müntəzəm və profilaktik texniki xidmət işləri həyata keçirilir.</p>
      
      <h4>2. Nasazlıqların analizi və troubleshooting</h4>
      <p>Avadanlıqlarda və sistemlərdə yaranan nasazlıqların kök səbəbləri təhlil edilir və effektiv troubleshooting həlləri tətbiq olunur.</p>
      
      <h4>3. Vibrasiya, səs-küy və qeyri-sabit iş rejimlərinin aradan qaldırılması</h4>
      <p>Vibrasiya, səs-küy və qeyri-sabit iş rejimləri diaqnostika edilərək sistemlərin stabil və təhlükəsiz işləməsi təmin olunur.</p>
      
      <h4>4. Operativ və planlı servis xidmətləri</h4>
      <p>İstismar tələblərinə uyğun olaraq həm operativ, həm də planlı servis xidmətləri göstərilərək dayanma riskləri minimuma endirilir.</p>
    `
  },
  {
    id: 5,
    slug: "preservation-services",
    title: "Preservation Xidmətləri",
    description: "Avadanlıqlar üçün qoruyucu tədbirlər və uzunmüddətli saxlanma həlləri",
    icon: "shield",
    image: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/c7yx1wkf_WhatsApp%20Image%202026-01-11%20at%2010.41.56_upscayl_3x_upscayl-standard-4x.png",
    heroImage: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/c7yx1wkf_WhatsApp%20Image%202026-01-11%20at%2010.41.56_upscayl_3x_upscayl-standard-4x.png",
    detailedContent: `
      <h3>Preservation Xidmətləri</h3>
      
      <h4>1. Dinamik və statik avadanlıqlar üçün preservation işləri</h4>
      <p>Dinamik və statik avadanlıqlar üçün kompleks preservation tədbirləri həyata keçirilir, avadanlıqların uzunmüddətli etibarlılığı və istismar hazırlığı təmin olunur.</p>
      
      <h4>2. Uzunmüddətli dayanma və ehtiyatda saxlanma üçün qoruyucu tədbirlər</h4>
      <p>Avadanlıqlar uzunmüddətli dayanma və ehtiyat rejimlərində qoruyucu tədbirlərlə təmin edilir, deqradasiya və əməliyyat riskləri minimuma endirilir.</p>
      
      <h4>3. Yağlama, örtükləmə, nəmlik və korroziyaya qarşı həllər</h4>
      <p>Avadanlıqların korroziyadan, nəmlikdən və aşınmadan qorunması üçün texniki həllər tətbiq olunur, uyğun yağlama və qoruyucu örtüklər təmin edilir.</p>
    `
  }
];

export const aboutData = {
  title: "Haqqımızda",
  shortDescription: `"Averon MMC" Miyawaki şirkəti ilə əməkdaşlıq çərçivəsində Azərbaycan üzrə rəsmi distribütor kimi steam trap sistemlərinin idarə olunması, texniki xidməti (maintenance), diaqnostikası, eləcə də yeni steam trap-ların təchizatı və quraşdırılması üzrə etibarlı və yüksək keyfiyyətli həllər təqdim edir. Təqdim etdiyimiz bütün həllər beynəlxalq standartlara uyğun, real istismar şəraitinə uyğunlaşdırılmış və enerji səmərəliliyinə yönəldilmişdir.`,
  fullDescription: `Şirkətimiz Miyawaki şirkəti ilə əməkdaşlıq çərçivəsində Azərbaycan üzrə rəsmi distribütor kimi steam trap sistemlərinin idarə olunması, texniki xidməti (maintenance), diaqnostikası, eləcə də yeni steam trap-ların təchizatı və quraşdırılması üzrə etibarlı və yüksək keyfiyyətli həllər təqdim edir. Təqdim etdiyimiz bütün həllər beynəlxalq standartlara uyğun, real istismar şəraitinə uyğunlaşdırılmış və enerji səmərəliliyinə yönəldilmişdir.

Şirkətimiz sənaye və kommersiya obyektləri üçün HVAC və mexaniki sistemlər üzrə ixtisaslaşmış mühəndislik, quraşdırma və texniki xidmət həlləri təqdim edir. Biz hər bir layihəyə texniki dəqiqlik, sahə təcrübəsi və uzunmüddətli etibarlılıq prinsipləri əsasında yanaşırıq. Göstərdiyimiz xidmətlər isitmə, soyutma, ventilyasiya, buxar və mexaniki sistemlərin bütün həyat dövrünü əhatə edir - layihələndirmə mərhələsindən istismara verilmə, servis və problemlərin aradan qaldırılmasına qədər. Həllərimiz beynəlxalq standartlara uyğun, real istismar şəraitinə uyğunlaşdırılmış və enerji səmərəliliyinə yönəldilmişdir.`,
  additionalDescription: `Şirkətimiz sənaye və kommersiya obyektləri üçün HVAC və mexaniki sistemlər üzrə ixtisaslaşmış mühəndislik, quraşdırma və texniki xidmət həlləri təqdim edir. Biz hər bir layihəyə texniki dəqiqlik, sahə təcrübəsi və uzunmüddətli etibarlılıq prinsipləri əsasında yanaşırıq. Göstərdiyimiz xidmətlər isitmə, soyutma, ventilyasiya, buxar və mexaniki sistemlərin bütün həyat dövrünü əhatə edir - layihələndirmə mərhələsindən istismara verilmə, servis və problemlərin aradan qaldırılmasına qədər. Həllərimiz beynəlxalq standartlara uyğun, real istismar şəraitinə uyğunlaşdırılmış və enerji səmərəliliyinə yönəldilmişdir.`,
  image: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/1fnyb0ql_mainhero.jpg",
  heroImage: "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg",
  detailedContent: `
    <p>Şirkətimiz Miyawaki şirkəti ilə əməkdaşlıq çərçivəsində Azərbaycan üzrə rəsmi distribütor kimi steam trap sistemlərinin idarə olunması, texniki xidməti (maintenance), diaqnostikası, eləcə də yeni steam trap-ların təchizatı və quraşdırılması üzrə etibarlı və yüksək keyfiyyətli həllər təqdim edir. Təqdim etdiyimiz bütün həllər beynəlxalq standartlara uyğun, real istismar şəraitinə uyğunlaşdırılmış və enerji səmərəliliyinə yönəldilmişdir.</p>
    
    <p>Şirkətimiz sənaye və kommersiya obyektləri üçün HVAC və mexaniki sistemlər üzrə ixtisaslaşmış mühəndislik, quraşdırma və texniki xidmət həlləri təqdim edir. Biz hər bir layihəyə texniki dəqiqlik, sahə təcrübəsi və uzunmüddətli etibarlılıq prinsipləri əsasında yanaşırıq. Göstərdiyimiz xidmətlər isitmə, soyutma, ventilyasiya, buxar və mexaniki sistemlərin bütün həyat dövrünü əhatə edir - layihələndirmə mərhələsindən istismara verilmə, servis və problemlərin aradan qaldırılmasına qədər. Həllərimiz beynəlxalq standartlara uyğun, real istismar şəraitinə uyğunlaşdırılmış və enerji səmərəliliyinə yönəldilmişdir.</p>
    
    <p>Şirkətimiz dinamik və statik avadanlıqların quraşdırılması, dəqiqlikli alignment işləri, vibrasiya analizi və vibrasiyaya qarşı texniki həllər üzrə güclü sahə təcrübəsinə malikdir. Grouting işlərindən sonra avadanlıqların stabil və təhlükəsiz işləməsini təmin etmək məqsədilə 3-komponentli epoksi materiallardan istifadə etməklə qabaqcıl vibrasiya izolyasiya həlləri tətbiq edirik.</p>
    
    <p>Biz həmçinin texniki xidmət, maintenance və troubleshooting sahəsində kompleks dəstək göstəririk. Avadanlıqlarda və sistemlərdə yaranan nasazlıqların kök səbəblərini təhlil edir, vibrasiya, səs-küy və qeyri-sabit iş rejimlərini aradan qaldıraraq sistemlərin etibarlı və fasiləsiz istismarını təmin edirik.</p>
    
    <p>Xidmət portfelimizə dinamik və statik avadanlıqlar üçün preservation işləri, uzunmüddətli dayanma (long-term shutdown) və ehtiyat rejimləri (standby conditions) zamanı avadanlıqların texniki vəziyyətinin qorunmasına yönəlmiş kompleks tədbirlər daxildir. Bu tədbirlər korroziyanın qarşısının alınması, mexaniki komponentlərin deqradasiyasının minimallaşdırılması, yağlama və konservasiya proseslərinin düzgün icrası, həmçinin avadanlıqların istismara problemsiz və təhlükəsiz qaytarılmasını təmin etmək məqsədilə beynəlxalq standartlara uyğun şəkildə həyata keçirilir.</p>
    
    <p><strong>Bizim əsas məqsədimiz</strong> - beynəlxalq standartlara uyğun təhlükəsiz, dayanıqlı və uzunömürlü sistemlər formalaşdırmaq, müştərilərimizin əməliyyat risklərini minimuma endirmək, avadanlıqların etibarlılığını və istismar səmərəliliyini maksimum səviyyəyə çatdırmaqdır.</p>
  `
};

export const statisticsData = [
  {
    id: 1,
    value: "500+",
    label: "Uğurlu Layihə",
    icon: "briefcase"
  },
  {
    id: 2,
    value: "15+",
    label: "İllik Təcrübə",
    icon: "calendar"
  },
  {
    id: 3,
    value: "50+",
    label: "Professional Komanda",
    icon: "users"
  },
  {
    id: 4,
    value: "100%",
    label: "Müştəri Məmnuniyyəti",
    icon: "award"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Elçin Məmmədov",
    position: "Texniki Direktor, ABC Company",
    text: "Averon Group ilə əməkdaşlıq bizim üçün əla təcrübə oldu. Peşəkar yanaşma və keyfiyyətli xidmət.",
    rating: 5
  },
  {
    id: 2,
    name: "Nigar Əliyeva",
    position: "Layihə Meneceri, XYZ Industries",
    text: "HVAC sistemlərinin quraşdırılması zamanı yüksək professional səviyyə nümayiş etdirdilər. Tövsiyə edirəm.",
    rating: 5
  },
  {
    id: 3,
    name: "Rəşad Həsənov",
    position: "Əməliyyat Rəhbəri, DEF Corporation",
    text: "Maintenance xidmətləri zamanı sürətli və effektiv həllər təqdim etdilər. Çox razıyıq.",
    rating: 5
  }
];

export const certificatesData = [
  {
    id: 1,
    name: "Miyawaki Distribütoru",
    description: "Azərbaycan üzrə Rəsmi Nümayəndə",
    pdfUrl: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/gerjxynf_AZ%20Partner.pdf"
  }
];

export const partnersData = [
  {
    id: 1,
    name: "Miyawaki GMBH",
    description: "Rəsmi Azərbaycan Distribütoru",
    logo: "https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/c4s3ps22_images.png",
    website: "https://www.miyawaki.de"
  }
];

export const contactData = {
  email: "info@averongroup.az / sales@averongroup.az",
  phone: "+994502950494",
  address: "Baku, Azerbaijan",
  socialMedia: [
    { name: "LinkedIn", url: "https://www.linkedin.com/company/averon-mechanical-engineering-services/", icon: "linkedin" }
  ]
};
